import React from 'react';

import { SelectInput } from 'hosman-material';

export const allSituations = [
  { id: 1, value: 'single', name: 'Célibataire' },
  { id: 2, value: 'married_pacsed', name: 'Marié(e) / Pacsé(e)' },
  { id: 3, value: 'divorced', name: 'Divorcé(e)' },
  { id: 4, value: 'widower', name: 'Veuf(ve)' },
]

const FamilySituationInput = ({ familySituation, setFamilySituation, errors }) => {
  const handleSelect = (option) => {
    setFamilySituation({ target: { name: 'family_situation', value: option.value }})
  }

  return (
    <div data-testid='FamilySituationInput'>
      <SelectInput
        name='family_situation'
        label='Situation familiale'
        options={allSituations}
        selectedOption={allSituations.find(option => option.value === familySituation)}
        handleChange={(option) => handleSelect(option)}
        errors={errors}
      />
    </div>
  );
}

export default FamilySituationInput;
